define('modules/editor/views/editors/popup',['require','exports','module','ckeditor','common/views/modal_view','../../models/editorstate','ckeditorJQuery','ldsh!../../templates/editors/popup','common/ckeditor/config_amp','common/ckeditor/config'],function(require,exports,module) {
  "use strict";
  var ckeditor = require("ckeditor"),
      ModalView = require("common/views/modal_view"),
      EditorState = require("../../models/editorstate");

  require("ckeditorJQuery");

  var PopupEditorView = ModalView.extend({
    template: require("ldsh!../../templates/editors/popup"),

    events: {
      "click .js-save": "saveModal",
      "click .js-close": "closeModal"
    },

    initialize: function (options) {
      this.popupName = options.name || '';
      this.popupTitle = options.title || '';
      this.popupContent = options.content || $.i18n.t('editor.popup.contentPlaceholder');
      this.CKEditorConfig = this.getCKEditorConfig();
    },

    getCKEditorConfig: function () {
      if (EditorState.getAMPState()) {
        return require("common/ckeditor/config_amp");
      }

      return require("common/ckeditor/config");
    },

    helpers: function() {
      var templateParams = {
        name: this.popupName,
        title: this.popupTitle,
        content: this.popupContent,
        isAMP: EditorState.getAMPState()
      };

      return templateParams;
    },

    closeModal: function() {
      this.hide();
    },

    saveModal: function(e) {
      e.preventDefault();
      var popupParams = this.getPopupData();

      this.trigger("modal:save", popupParams);
    },

    getPopupData: function() {
      return {
        name:  this.$("#popupName").val(),
        title:  this.$("#popupTitle").val(),
        content:  this.$("#ckeditor").val()
      };
    },

    onRender: function() {
      CKEDITOR.disableAutoInline = true;
      this.editor = this.$("#ckeditor").ckeditor(this.CKEditorConfig);
      this.$el.i18n();
    },

    onHide: function() {
      this.$("#ckeditor").ckeditor("destroy");
    }
  });

  module.exports = PopupEditorView;
});

